function isAdmin(permissions) {
  var admin = permissions.some(
    p => p.Permission_Id == 1 && p.Organization_Id == 1
  );
  return admin;
}

const permissions = {
  /*** Database ***/
  getAllPermissions: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{
          GetAllPermissions {
              Permission_Id
              Title
              Description
              Permission_Type{
                Permission_Type_Id
                Title
              }
          }
        }`
      })
      .then(r => {
        return r.data.GetAllPermissions;
      });
  },

  createNewAccountUserPermission: async function(userId, accountId) {
    const query = `
      mutation($userId: Int!, $accountId: Int!, $permissionIds: [Int]!) {
        CreateUserAccountPermission(userId: $userId, accountId: $accountId, permissionIds: $permissionIds)
      }`;
    const variables = {
      userId: parseInt(userId),
      accountId: parseInt(accountId),
      permissionIds: [2]
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createUserPermissionsForAccount: async function(
    userId,
    accountId,
    permissionIds
  ) {
    const query = `
      mutation($userId: Int!, $accountId: Int!, $permissionIds: [Int]!) {
        CreateUserAccountPermission(userId: $userId, accountId: $accountId, permissionIds: $permissionIds)
      }`;
    const variables = {
      userId: parseInt(userId),
      accountId: parseInt(accountId),
      permissionIds: permissionIds.map(p => parseInt(p))
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createUserPermissionsForOrganizations: async function(
    userId,
    organizationPermissions
  ) {
    var formattedOrganizationPermissions = [];
    organizationPermissions.forEach(organizationPermission => {
      formattedOrganizationPermissions.push({
        Organization_Id: parseInt(organizationPermission.organization),
        Permission_Id: parseInt(organizationPermission.permission)
      });
    });
    const query = `
      mutation($userId: Int!, $organizationPermissions: [OrganizationPermission]!) {
        CreateUserOrganizationPermissions(userId: $userId, organizationPermissions: $organizationPermissions)
      }`;
    const variables = {
      userId: parseInt(userId),
      organizationPermissions: formattedOrganizationPermissions
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createUserPermissionsForSubjects: async function(userId, subjectPermissions) {
    var formattedSubjectPermissions = [];
    subjectPermissions.forEach(subjectPermission => {
      formattedSubjectPermissions.push({
        Subject_Id: parseInt(subjectPermission.subject),
        Permission_Id: parseInt(subjectPermission.permission)
      });
    });
    const query = `
      mutation($userId: Int!, $subjectPermissions: [SubjectPermission]!) {
        CreateUserSubjectPermissions(userId: $userId, subjectPermissions: $subjectPermissions)
      }`;
    const variables = {
      userId: parseInt(userId),
      subjectPermissions: formattedSubjectPermissions
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createUserPermissionsForStudent: async function(
    userIds,
    studentId,
    permissionId
  ) {
    const query = `
      mutation($studentId: Int!, $userIds: [Int]!, $permissionId: Int!) {
        CreateUserStudentPermission(studentId: $studentId, userIds: $userIds, permissionId: $permissionId)
      }`;
    const variables = {
      userIds: userIds.map(u => parseInt(u)),
      studentId: parseInt(studentId),
      permissionId: parseInt(permissionId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createSingleUserStudentPermission: async function(
    userId,
    studentId,
    permissionId
  ) {
    const query = `
      mutation($userId: Int!, $studentId: Int!, $permissionId: Int!) {
        CreateSingleUserStudentPermission(userId: $userId, studentId: $studentId, permissionId: $permissionId){
          User_Permission_Id
        }
      }`;
    const variables = {
      userId: parseInt(userId),
      studentId: parseInt(studentId),
      permissionId: parseInt(permissionId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateSingleUserStudentPermission);
  },

  createSingleUserSubjectPermission: async function(
    userId,
    subjectId,
    permissionId
  ) {
    const query = `
      mutation($userId: Int!, $subjectId: Int!, $permissionId: Int!) {
        CreateSingleUserSubjectPermission(userId: $userId, subjectId: $subjectId, permissionId: $permissionId){
          User_Permission_Id
        }
      }`;
    const variables = {
      userId: parseInt(userId),
      subjectId: parseInt(subjectId),
      permissionId: parseInt(permissionId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateSingleUserSubjectPermission);
  },

  createSingleUserOrganizationPermission: async function(
    userId,
    organizationId,
    permissionId
  ) {
    const query = `
      mutation($userId: Int!, $organizationId: Int!, $permissionId: Int!) {
        CreateSingleUserOrganizationPermission(userId: $userId, organizationId: $organizationId, permissionId: $permissionId){
          User_Permission_Id
        }
      }`;
    const variables = {
      userId: parseInt(userId),
      organizationId: parseInt(organizationId),
      permissionId: parseInt(permissionId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateSingleUserOrganizationPermission);
  },

  removeUserPermissions: async function(userPermissionIds) {
    const query = `
      mutation($userPermissionIds: [Int]!) {
        DeleteUserPermissions(userPermissionIds: $userPermissionIds)
      }`;
    const variables = {
      userPermissionIds: userPermissionIds.map(p => parseInt(p))
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  checkPermissionToSeeStudent: async function(userId, studentId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          CheckUserStudentPermission(userId: ` +
          parseInt(userId) +
          ` studentId: ` +
          parseInt(studentId) +
          `) 
        }`
      })
      .then(r => {
        return r.data;
      });
  },

  canSeeAllTabs: function(permissions) {
    return (
      permissions.length > 0
    );
  },

  /*** Account ***/
  canSeeAccountSettings: function(permissions, accountId) {
    return (
      this.$canManageAccount(permissions, accountId) ||
      this.$canViewAccount(permissions, accountId)
    );
  },
  canManageAccount: function(permissions, accountId) {
    if (isAdmin(permissions)) {
      return true;
    }
    return permissions.some(
      p => p.Account_Id == accountId && p.Permission_Id == 2
    );
  },
  canViewAccount: function(permissions, accountId) {
    if (isAdmin(permissions)) {
      return true;
    }
    return permissions.some(
      p => p.Account_Id == accountId && p.Permission_Id == 3
    );
  },

  canManageOrganization: function(permissions, organizationId) {
    if (isAdmin(permissions)) {
      return true;
    }
    return permissions.some(
      p => p.Organization_Id == organizationId && p.Permission_Id == 4
    );
  },
  canViewOrganization: function(permissions, organizationId, accountId) {
    if (isAdmin(permissions) || this.$canViewAccount(permissions, accountId)) {
      return true;
    }
    return permissions.some(
      p => p.Organization_Id == organizationId && p.Permission_Id == 5
    );
  },

  /*** Student ***/
  canManageStudent: function(permissions, studentId) {
    if (isAdmin(permissions)) {
      return true;
    }
    return permissions.some(
      p => p.Student_Id == studentId && p.Permission_Id == 8
    );
  },
  canViewStudent: function(permissions, studentId) {
    if (isAdmin(permissions)) {
      return true;
    }
    return permissions.some(
      p => p.Student_Id == studentId && p.Permission_Id == 9
    );
  },

  /*** Subject ***/
  canManageSubject: function(permissions, subjectId, organizationId) {
    if (
      isAdmin(permissions) ||
      this.$canManageOrganization(permissions, organizationId)
    ) {
      return true;
    }
    return permissions.some(
      p => p.Subject_Id == subjectId && p.Permission_Id == 6
    );
  },
  canViewSubject: function(permissions, subjectId) {
    if (isAdmin(permissions)) {
      return true;
    }
    return permissions.some(
      p => p.Subject_Id == subjectId && p.Permission_Id == 7
    );
  }
};

export { permissions };
